import { useEffect } from "react";
import { useAppDispatch } from "../../app/store";
import { showToast } from "../../stores/notifications/notificationsSlice";

export default function LogoutRoute() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    localStorage.clear();
    dispatch(
      showToast({ message: "Successfully logged out!", severity: "success" }),
    );

    window.location.replace("/");
  }, [dispatch]);

  return null;
}
